import { TODO } from '@b2b/types/core/utils';
import angular, { IScope } from 'angular';
import { AddressCreateDirectiveModule } from './create/create.directive';
import { AddressListModule } from './list/list';

AddressDirective.$inject = [];

function AddressDirective() {
  AddressController.$inject = ['$scope'];

  function AddressController($scope: IScope & { address: TODO }) {
    $scope.address = {};
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/address/address.tpl.html',
    scope: {
      model: '=',
      enableEdit: '@',
      editAction: '&',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: AddressController,
  };
}

export const AddressDirectiveModule = angular
  .module('acme.common.directive.address', [
    AddressListModule,
    'acme.common.directive.addressDetail',
    AddressCreateDirectiveModule,
  ])
  .directive('address', AddressDirective).name;
